export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6746.2c5c7ea8.jpg";